import { render, staticRenderFns } from "./LargeHighlights.vue?vue&type=template&id=15a5ae18&scoped=true&"
import script from "./LargeHighlights.vue?vue&type=script&lang=js&"
export * from "./LargeHighlights.vue?vue&type=script&lang=js&"
import style0 from "./LargeHighlights.vue?vue&type=style&index=0&id=15a5ae18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a5ae18",
  null
  
)

export default component.exports